import { render, staticRenderFns } from "./addAccident.vue?vue&type=template&id=6ad15532&scoped=true&"
import script from "./addAccident.vue?vue&type=script&lang=js&"
export * from "./addAccident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad15532",
  null
  
)

export default component.exports